import Select, { SelectProps, SelectChangeEvent } from "@mui/material/Select";

export type { SelectProps, SelectChangeEvent };
export default Select;
